'use es6';

import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { getName } from 'dashboard-lib/public/report/report-schema';
import { Header } from 'foundations-components/transitional/components/Header';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailReportCard = ({
  children,
  overriddenReport
}) => {
  return (
    /*#__PURE__*/
    // required className for BE screen capture
    // @bend-expect trellis-tokenized
    _jsx("div", {
      className: "screen-capture-report",
      children: /*#__PURE__*/_jsx("div", {
        className: "report-container",
        children: /*#__PURE__*/_jsxs("div", {
          className: "report-card",
          "data-test-id": "email-report-preview-card",
          children: [getName(overriddenReport) && /*#__PURE__*/_jsx(Header, {
            flush: true,
            use: "condensed",
            padding: "0",
            title: /*#__PURE__*/_jsx(Text, {
              as: "h2",
              inlineSize: "100%",
              marginBlockEnd: "400",
              truncate: true,
              whiteSpace: "nowrap",
              color: "fill-accent-neutral-default",
              children: /*#__PURE__*/_jsx(TruncateString, {
                useFlex: true,
                children: getName(overriddenReport)
              })
            })
          }), children]
        })
      })
    })
  );
};
export default EmailReportCard;